import {ISetUserParams, TUserParams} from '../actions/user-params.action';

export enum EnumUserParam {
  REMOTE_SCHEDULE_EDIT
}

export interface IUserParams {
  active: boolean;
  param: EnumUserParam;
}

export type IUserParamsState = IUserParams[];

export const defaultUserParamsState: IUserParamsState = [{
  active: false,
  param: EnumUserParam.REMOTE_SCHEDULE_EDIT
}];

export const userParamsReducer = (
  state: IUserParamsState = defaultUserParamsState,
  action: ISetUserParams
): IUserParamsState => {
  switch (action.type) {
    case TUserParams.SET_USER_PARAMS:
      return action.payload;
    default:
      return state;
  }
};
